const normalizeStatus = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

export const resolveIdVerificationDisplayState = (payload) => {
  if (payload?.idVerificationRequested === false) return "not_requested";
  if (payload?.idVerificationRequested == null) return "unavailable";

  const verification = payload?.idVerification || {};
  const status = normalizeStatus(payload?.status || verification?.status);
  if (["required", "pending", "queued", "processing"].includes(status)) {
    return "pending";
  }
  if (["verified", "pass", "passed"].includes(status)) return "verified";
  if (["failed", "fail", "no_match", "mismatch"].includes(status)) {
    return "failed";
  }
  if (status === "error") return "error";
  if (verification?.idVerificationPass === true) return "verified";
  if (verification?.idVerificationPass === false) return "failed";

  return "pending";
};

export const getIdVerificationMatchMessage = (nameMatches, birthDateMatches) => {
  if (nameMatches && birthDateMatches) {
    return "Verification Successful: The name and date of birth on the uploaded ID match the booking information.";
  }
  return "Verification Failed: The name and/or date of birth on the uploaded ID does not match the booking information.";
};
